/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ItineratorError, ItineratorNewsletter, ItineratorNewsletterList } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Newsletters<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Newsletter
   * @name GetNewsletters
   * @summary List all newsletters
   * @request GET:/newsletters
   * @secure
   */
  getNewsletters = (params: RequestParams = {}) =>
    this.request<ItineratorNewsletterList, ItineratorError>({
      path: `/newsletters`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Newsletter
   * @name GetNewsletterBySlug
   * @summary Find a newsletter by slug
   * @request GET:/newsletters/{slug}
   * @secure
   */
  getNewsletterBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorNewsletter, ItineratorError>({
      path: `/newsletters/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
